import React, {useState} from "react";
import {Tooltip, Tabs} from 'antd';
import CardHighchartsPie from "../../../utils/module/CardHighchartsPie";
import CardHighchartsSpline from "../../../utils/module/CardHighchartsSpline";
import {alarm_hint_tooltip_css as alarmHintTooltipCss} from "../../../utils/PublicConstant";
import Icon from "@ant-design/icons";
import alarmImg from "../../../imagers/icon/alarm.png";

interface CardData{
    param:any,
    realData:any,
    setItems:any,
    setActiveKey:any,
    items:any,
    viewTypeList:any,
    setViewTypeList:any;
    viewOperate:any;
}
const AntiDropPreview: React.FC<CardData> = (cardData) => {
    const [data,setData] = useState({hstDistance:"",hstSpeed:'',hstRotSpeedL:'',hstRotSpeedQcb3:'',hstRotSpeedRatio:'',hstBrakeLength1Qrl1:'',hstBrakeTime1Qrl1:''
        ,alarmInfo:{fault:"",state:""}});
    React.useEffect(() => {
        let newData = cardData.realData?.find((item:any) => item.id == cardData.param.id)?.data;
        setData(newData ?? data);
    },[cardData.realData]);
    return (
        <>
            <div className={"preview-tabs-head"}>
                <div className={"preview-tabs-content"} style={{height:"225px"}}>
                    <table className="table table-borderless">
                        <tbody>
                        <tr>
                            <td colSpan={2} width="50%">起升高度：{data.hstDistance} m</td>
                            <td colSpan={2} width="50%">卷筒转速：{data.hstRotSpeedL} r/min</td>
                        </tr>
                        <tr>
                            <td colSpan={2} width="50%">起升速度：{data.hstSpeed} m/min</td>
                            <td colSpan={2} width="50%">电机转速：{data.hstRotSpeedQcb3} r/min</td>
                        </tr>
                        <tr>
                            <td colSpan={2} width="50%">制动距离：{data.hstBrakeLength1Qrl1} m</td>
                            <td colSpan={2} width="50%">减速比：{data.hstRotSpeedRatio}</td>
                        </tr>
                        <tr>
                            <td colSpan={2} width="50%">制动时间：{data.hstBrakeTime1Qrl1} s</td>
                            <td colSpan={2} width="50%"></td>
                        </tr>
                        <tr>
                            <td colSpan={4}>
                                <div className="alarm-info" id={"alarmDiv"}>
                                    <div className="alarm-info-title">故障提示：{data.alarmInfo?.fault}</div>
                                    <div className="alarm-info-content">
                                        <Tooltip title={data.alarmInfo?.state} color="#C9CACA" overlayInnerStyle={alarmHintTooltipCss} placement="bottom">
                                            <div className="alarm-hint-tooltip-content"><span className="cancel-bold">{data.alarmInfo?.state}</span></div>
                                        </Tooltip>
                                    </div>
                                    <div style={{margin:"0px 3px"}}>
                                        <Icon component={() => (<img src={alarmImg} style={{width:"13px",height:"13px",display:data.alarmInfo?.fault === '0-无故障'?"none":"block"}}/>)}/>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className={"preview-tabs-head"} style={{marginTop:"10px"}}>
                <Tabs defaultActiveKey="1" type="card" size={"middle"} style={{}} onChange={(activeKey:string)=>{}}
                      items={[
                          {
                              key:"1",
                              label:<span className="preview-tabs-head-label">报警显示</span>,
                              children:<CardHighchartsPie param={cardData.param} seriesData={cardData.param.data?.alarmSumItems} />
                          },
                          {
                              key:"2",
                              label:<span className="preview-tabs-head-label">制动性能</span>,
                              children:<CardHighchartsSpline tickPositions={null} realData={[data?.hstBrakeLength1Qrl1,data?.hstBrakeTime1Qrl1]}
                                                               param={cardData.param} series={['制动距离(m)','制动时间(s)']} />
                          }
                      ]}
                />
            </div>
        </>
    )
}
export default AntiDropPreview;